

import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";

export class MultiplierBetWins implements GameRoundPresentation {

    private _reset:boolean = false

    constructor(reset:boolean = false) {
        this._reset = reset;
    }

    getAnimation():Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._reset) {
            tl.add(() => {
                HarlequinGameModuleConfig.multiplierBetWinView.resetAllActives();
            });
        }

        return tl;
    }

    prepare(data:HarlequinParsedGameData):void {
     /*
        betLineWins: Array(20)
        0:
        amount: 0.35
        betLine: (5) [1, 1, 1, 1, 1]
        betLineIndex: 0
        multipliedAmount: 1.75
        multiplier: 1
        nrOfSymbols: 3
        symbol: "M4"
        winPosition: (5) [true, true, true, false, false]
      */
        //console.log("MULTIPLIER BET WINS");
        //console.log(data!.betLineWins);

    }

}